export const CREATE_JOB_YARN_RETURN = 'CREATE_JOB_YARN_RETURN';
export const GET_JOB_YARN_RETURN = 'GET_JOB_YARN_RETURN';
export const JOB_YARN_RETURN_REQUEST = 'JOB_YARN_RETURN_REQUEST';
export const JOB_YARN_RETURN_REQUEST_SUCCESS = 'JOB_YARN_RETURN_REQUEST_SUCCESS';
export const UPDATE_JOB_YARN_RETURN = 'UPDATE_JOB_YARN_RETURN';
export const DELETE_JOB_YARN_RETURN = 'DELETE_JOB_YARN_RETURN';
export const JOB_YARN_RETURN_REQUEST_FAILURE = 'JOB_YARN_RETURN_REQUEST_FAILURE';
export const GET_JOB_YARN_RETURNS_PAGE = 'GET_JOB_YARN_RETURNS_PAGE';
